import Vue from 'vue'
import Notify from 'vue-notifyjs'

export default Vue.use(Notify, {
  type: 'primary', timeout: 2000
})
